import { Flex, Link, SecondaryButton, SystemProps, Text, LegacyText } from "flicket-ui";
import React, { FC } from "react";

export const NonLoggedInRenewalBanner: FC<SystemProps> = (props) => (
  <Flex
    flexDir={{ md: "row", _: "column" }}
    width="100%"
    border={"2px"}
    borderColor="N100"
    padding={2}
    justifyContent="space-between"
    borderRadius={"md"}
    alignItems="center"
    {...props}
  >
    <Flex flexDir={"column"}>
      <LegacyText fontWeight={"heavy"} fontSize={4} color={"N800"}>
        Have a membership from last season?
      </LegacyText>
      <LegacyText
        mt={{ _: 2, md: 1 }}
        fontSize={4}
        mb={{ _: 3, md: 0 }}
        color={"N800"}
      >
        Your previous seats will be held for a limited time. Log in to renew
        your membership.
      </LegacyText>
    </Flex>
    <Link
      to="/login?redirect=members-area?open=true"
      width={{ _: "100%", md: "auto" }}
    >
      <SecondaryButton shadow={"button"} height={46}>
        Renew my membership
      </SecondaryButton>
    </Link>
  </Flex>
);
